module.exports = __webpack_public_path__ + "media/message.7fd8e56e.mp3";